module.exports = __webpack_public_path__ + "static/media/8.271842a0.png";